module.exports = __webpack_public_path__ + "media/Images/ParticipantsCount-37202524.svg";